<app-modal [modalTitleText]="headerText" [cancelButtonText]="closeText" [primaryButtonEnabled]="false" (cancelButtonAction)="closeModal()">
  <app-privacy-policy [footerStickyEnabled]="false" modal-content></app-privacy-policy>
</app-modal>
